import { service } from '../../../../helpers/http'

//Retorna a lista com as categorias de grupos
export const ActionGetAmbienceResources = ({ dispatch }, payload) => {

    return service({
        module: 'domainAmbienceResource',
        action: 'getAmbienceResources',
        payload: payload
    })
    
}

//Cadastra uma nova categoria de grupo
export const ActionPostAmbienceResources = ({ dispatch }, payload) => {

    return service({
        module: 'domainAmbienceResource',
        action: 'postAmbienceResources',
        payload: payload
    })
    
}

//Atualiza uma categoria de grupo
export const ActionPutAmbienceResources = ({ dispatch }, payload) => {

    return service({
        module: 'domainAmbienceResource',
        action: 'putAmbienceResources',
        payload: payload
    })
    
}

//Deleta uma categoria de grupo
export const ActionDeleteAmbienceResources = ({ dispatch }, payload) => {

    return service({
        module: 'domainAmbienceResource',
        action: 'deleteAmbienceResources',
        payload: payload
    })
    
}